<template>
  <div class="page">
    <div class="app-container">
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/groups/index"
        :tableData.sync="tableData"
        :columns="columns"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>

      <el-drawer
        :title="title"
        :visible.sync="isShowDrawer"
        direction="rtl"
        @close="drawerClose"
      >
        <div style="padding: 40px">
          <el-form
            :model="formData"
            :rules="rules"
            labelWidth="100px"
            size="medium"
          >
            <el-form-item label="岗位名称" required>
              <el-input v-model="formData.title"></el-input>
            </el-form-item>
            <el-form-item label="状态" required>
              <el-radio-group v-model="formData.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="岗位描述">
              <el-input
                type="textarea"
                v-model="formData.content"
                rows="4"
              ></el-input>
            </el-form-item>
            <el-form-item label="权限">
              <el-tree
                ref="tree"
                :data="getRulesList"
                :default-checked-keys="defaultChecked"
                :props="defaultProps"
                default-expand-all
                show-checkbox
                node-key="id"
                @check="checkHandle"
                accordion
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { getListInfoByGid } from "@/api/rules";
import { columns, rules } from "./columns";
import { getinfo } from "@/api/roles";
import treeUtil from "@/utils/tree";

export default {
  name: "Post",
  comments: {},
  data() {
    return {
      tableData: [],
      isShowDrawer: false,
      formData: {},
      searchData: {},
      isEdit: false,
      title: "",
      ruleList: [],
      defaultChecked: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      pids: []
    };
  },
  computed: {
    columns,
    rules,
    getRulesList() {
      return treeUtil.listToTreeMulti(this.ruleList);
    },
  },
  created() {},
  methods: {
    getRules(gid) {
      // getListAll().then(response => {
      //   this.ruleList = response.data.data
      // })
      // var param = {
      //   gid: gid,
      // };
      // getListInfoByGid(param).then((res) => {
      //   this.ruleList = res.data.data.filter((item) => item.status);
      // });


      return new Promise((resolve, reject) => {
        var param = {
            gid: gid
        };
        getListInfoByGid(param).then((res) => {
          if (res && res.data && res.data.data) {
              // 筛选出满足条件的规则列表
              this.ruleList = res.data.data.filter((item) => item.status);
              console.log(this.ruleList);
              // 成功时将处理后的ruleList通过resolve传递出去
              resolve(this.ruleList);
          } else {
              console.error('返回数据格式不符合预期');
              // 拒绝Promise，并传递错误信息
              reject(new Error('返回数据格式不符合预期'));
          }
        }).catch((error) => {
          console.error('获取规则列表信息失败：', error);
          // 出现获取数据的错误时，拒绝Promise，并传递具体错误
          reject(error);
        });
      });

    },
    checkHandle() {
      const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys().join(",");
      const checkedKeys = this.$refs.tree.getCheckedKeys().join(",");
      if (halfCheckedKeys.length && checkedKeys.length) {
        this.formData.rules = halfCheckedKeys + "," + checkedKeys;
      } else if (halfCheckedKeys.length && checkedKeys.length === 0) {
        this.formData.rules = halfCheckedKeys;
      } else if (halfCheckedKeys.length === 0 && checkedKeys.length) {
        this.formData.rules = checkedKeys;
      } else {
        this.formData.rules = "";
      }
    },
    // 点击搜索
    handleSearch() {
      console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },
    add() {
      this.getRules(0);
      this.isShowDrawer = true;
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([]);
      }
      this.formData = {
        ...this.formData,
        status: 1,
      }
      this.title = "新增岗位";
    },

    async edit(row) {
      this.getRules(row.id);
      const _this = this;
      getinfo(row.id).then((response) => {
        if (response.status === 1) {
          _this.formData.id = response.data.id;
          _this.formData.title = response.data.title;
          _this.formData.status = response.data.status;
          // _this.formData.rules = response.data.rules;

          // 递归遍历ruleList的pid，输出一个数组
          this.getPids(_this.ruleList)
          let r = response.data.rules.split(',')
          // 比对pids 和 r ，如果存在，则删除r中的数组元素
          r.forEach((item,i)=>{
            _this.pids.forEach(pid=>{
              console.log(item,pid);
              if(item == pid){
                // 删除r中的数组元素
                r[i] = ''
              }
            })
          })
          r = r.filter(item => item.length > 0)
          this.$refs.tree.setCheckedKeys(r);

          // this.$refs.tree.setCheckedKeys(_this.formData.rules.split(","));
        }
      });
      this.isEdit = true;
      this.isShowDrawer = true;
      this.title = "编辑岗位";
      this.formData = {
        ...row,
      };
    },

    getPids(e){
      e.forEach(item=>{
        this.pids.push(item.pid);
        if(item.children && item.children.length > 0){
          this.getPids(item.children)
        }
      })
      this.pids = [...new Set(this.pids)];
    },


    del({ id }) {
      this.$confirm("是否确认删除该岗位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post("/admin/quarters/del", { id }, "删除");
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    async onSubmit() {
      await this.$api.post(
        "/admin/groups/save",
        this.formData,
        this.isEdit ? "编辑" : "添加"
      );
      this.isShowDrawer = false;
      this.handleSearch();
    },

    // 抽屉关闭
    drawerClose() {
      this.formData = {};
    },
  },
};
</script>
